import { Link } from "react-router-dom";
import { imgUrl } from "@/lib/api";

export const ProductCard = ({ product }) => (
  <Link to={`/store/${product.id}`} className="group block" data-testid={`product-card-${product.id}`}>
    <div className="img-frame aspect-[4/5] bg-[#F6F5F2]">
      <img src={imgUrl(product.image_url)} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
    </div>
    <div className="mt-4">
      <p className="label-eyebrow text-[#9E8773] text-[10px]">{product.category}</p>
      <h3 className="font-display text-xl sm:text-2xl font-medium text-[#2C2A29] mt-1 group-hover:text-[#9E8773] transition-colors">
        {product.name}
      </h3>
      {product.collection && <p className="text-sm text-[#5E5A54] font-light mt-0.5">{product.collection}</p>}
    </div>
  </Link>
);
